// src/modules/app-views/goodsReceipt/pages/Document/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SaveOutlined } from '@ant-design/icons';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const goodsReceiptDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: <SaveOutlined />,
    type: 'primary',
    // Disable save button when the document is in a locked status
    disabled: ({ page }) => {
      const status = page?.data?.status;
      return status === 'confirmed';
    },
    // Use 'submit' directly from context instead of moduleContext.formContext
    onClick: ({ submit }) => submit?.(),
    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default goodsReceiptDocumentActionButton;
